import * as React from 'react';
import { Link } from 'components/link/Link';

import s from './DescriptiveListItem.scss';

interface IRowProps {
  title?: string;
  link?: string;
  text?: string | React.ReactElement<any>;
  footer?: string | React.ReactElement<any>;
}

export const DescriptiveListItem = ({ link, title, text, footer }: IRowProps) => {
  if (!title && !text) {
    return null;
  }

  const renderedTitle = link ? <Link to={link}>{title}</Link> : title;

  return (
    <>
      <dt className={s.descriptiveListItem__dt}>        
        {renderedTitle}
      </dt>
      <dd className={s.descriptiveListItem__dd}>
        {text}

        {footer && (<span className={s.descriptiveListItem__footer}>{footer}</span>)}
      </dd>
    </>
  );
};
